import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { getManualPaymentStatusOnGuestRoundAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getManualPaymentStatusOnGuestRound/getManualPaymentStatusOnGuestRound";
import { getRoundFromIdAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";
import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import { Text } from "@whoosh/design-system/src/components/primitive";

import { setPaymentStatusOnGuestRoundAtom } from "../../../../../../../atoms/actions/setPaymentStatusOnGuestRound/setPaymentStatusOnGuestRound";

type Props = {
  roundId: string;
};

export const BillMemberEdit = ({ roundId }: Props) => {
  const setPaymentStatusOnGuestRound = useSetAtom(
    setPaymentStatusOnGuestRoundAtom
  );
  const currentRound = useAtomValue(getRoundFromIdAtom(roundId));

  const manualPaymentStatus =
    useAtomValue(getManualPaymentStatusOnGuestRoundAtom(roundId)) ||
    "AUTO_CHARGE";

  return (
    <>
      <Text
        variant="mainSmallSemiBold"
        color="text-primary"
      >{t`Bill Member`}</Text>
      <DropdownSelect
        options={[
          {
            label: t`Yes. Host will pay all guest fees`,
            value: "AUTO_CHARGE",
          },
          {
            label: t`No. Guest will pay all their fees`,
            value: "PAYMENT_EXPECTED",
          },
        ]}
        value={manualPaymentStatus}
        onChange={(value) => {
          const newPaymentStatus =
            value === "AUTO_CHARGE" ? "AUTO_CHARGE" : "PAYMENT_EXPECTED";
          setPaymentStatusOnGuestRound({
            roundId: currentRound?.localId ?? "",
            manualPaymentStatus: newPaymentStatus,
          });
        }}
      />
    </>
  );
};
